import config from 'services/config'

const Flag = ({ children: country, className }) => {
  if (!country) return null

  const imgUrl = `${config.s3AssetsUrl}/flags/${country.toUpperCase()}.svg`

  return <img className={className} src={imgUrl} alt={country} />
}

export default Flag
